import { useQuery } from '@tanstack/react-query'

import { getFileContent, listBucketContents } from 'services/results'

const MultiQcFileName: string = 'multiqc_report.html'

const useMultiQcFetcher = ({
  runId,
  bucket,
  rootUrl,
  enabled
}: {
  runId: string
  bucket?: string
  rootUrl?: string
  enabled?: boolean
}): string | undefined => {
  const multiQcPath: string = `${rootUrl}/results/MultiQC`

  const multiQcDirQuery = useQuery({
    queryKey: ['s3-contents', bucket, multiQcPath],
    queryFn: () => listBucketContents(runId, bucket!, multiQcPath),
    enabled: !!bucket && !!rootUrl && !!enabled
  })

  const doesMultiQcExist: boolean = !!multiQcDirQuery.data?.contents.find(item => item.name === MultiQcFileName)

  const multiQcFileQuery = useQuery({
    queryKey: ['multiqc-file-content', bucket, multiQcPath],
    queryFn: () => getFileContent({ runId, bucket: bucket!, fileKey: `${multiQcPath}/${MultiQcFileName}` }),
    retry: false,
    enabled: !!bucket && !!rootUrl && !!enabled
  })

  if (!doesMultiQcExist || !multiQcFileQuery.data?.fileContent) return undefined

  return multiQcFileQuery.data?.fileContent
}

export default useMultiQcFetcher
